import React from 'react';
import { useTradingViewWidget } from '../hooks/useTradingViewWidget';

const CONFIG = {
  symbols: [
    { proName: 'FOREXCOM:SPXUSD', title: 'S&P 500' },
    { proName: 'FOREXCOM:NSXUSD', title: 'US 100' },
    { proName: 'FX_IDC:EURUSD', title: 'EUR/USD' },
    { proName: 'FX_IDC:USDJPY', title: 'USD/JPY' },
    { proName: 'FX_IDC:GBPUSD', title: 'GBP/USD' },
    { proName: 'FX_IDC:AUDUSD', title: 'AUD/USD' },
    { proName: 'BINANCE:BTCUSDT', title: 'Bitcoin' },
    { proName: 'BINANCE:ETHUSDT', title: 'Ethereum' },
    { proName: 'TVC:GOLD', title: 'Gold' },
    { proName: 'TVC:USOIL', title: 'Crude Oil' }
  ],
  showSymbolLogo: true,
  colorTheme: 'dark',
  isTransparent: true,
  displayMode: 'adaptive',
  locale: 'en'
};

const TradingViewTickerTape = () => {
  const containerRef = useTradingViewWidget(
    'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js',
    CONFIG
  );

  return <div className="tradingview-widget-container" ref={containerRef} data-testid="ticker-tape-widget" />;
};

export default TradingViewTickerTape;
